import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/ReturnReport/WarehouseReportReturnAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class APReportReturnActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/ReturnReport/WarehouseReportReturn")
	}

	render() {
		return (
			<Activity 
				name="APReportReturn"
				RenderedComponent={this.RenderedComponent}
				context="APReportReturn"
				action="WarehouseReportReturn"
				formActions={FormAction}/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(APReportReturnActivity)
